<template>
  <div class="hc_lnav jslist">
    <!-- <div class="topBar">
      <span style="width: 75px; margin-right: 60px">选择职位</span>
      <el-input
        placeholder="请输入职位关键字"
        prefix-icon="el-icon-search"
      ></el-input>
    </div> -->
    <div class="allbtn">
      <ul
        style="width: 150px; height: 500px; overflow-y: scroll"
        class="jspop box"
      >
        <li
          class="a1"
          v-for="item in this.$store.state.sys_dicts.categories"
          @click="showSubMenus(item)"
        >
          <div class="tx">
            <el-row>
              <el-col :span="24">
                <a href="#">
                  <span>{{ item.cate.name }}</span>
                </a>
              </el-col>
            </el-row>
          </div>
        </li>
      </ul>
      <div class="content">
        <div class="pop">
          <template v-if="subMenus.cate">
            <el-row class="menuRow" v-for="subItem in subMenus.subMenus">
              <el-col :span="4" class="menuTitle">{{
                subItem.cate.name
              }}</el-col>
              <el-col :span="20" class="menus">
                <a
                  class="ui-link"
                  href="#"
                  @click="selectValue(subs.name)"
                  v-for="subs in subItem.subMenus"
                  >{{ subs.name }}</a
                >
              </el-col>
            </el-row>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { getAction } from "@/comm/manage";

export default {
  name: "IndustryComp",
  data() {
    return {
      url: {
        list: "/sys/category/allList",
        // list: "/sys/category/rootList",
        // childList: "/sys/category/childList",
      },
      menuList: [],
      hotMenu: [],
      subMenus: {},
    };
  },
  methods: {
    loadData(arg) {
      let params = {};
      //目前为一次性加载所有分类导航，减少网络IO
      // return new Promise((resolve) => {
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.menuList = res.result;
          // this.menuList.forEach(element => {
          //   element.subMenus.forEach(ele =>{
          //     ele.subMenus.forEach(e => {
          //       let obj = {}
          //       if(e.isHot == "true"){
          //         obj.name = element.cate.name;
          //         obj.subName = e.name;
          //         this.hotMenu.push(obj);
          //       }
          //     })
          //   })
          // });
        } else {
          this.$message.warning(res.message);
        }
      });
      // })
    },
    selectValue(value) {
      this.$emit("selectValue", value);
    },
    showSubMenus(item) {
      this.subMenus = item;
    },
    //可以使用异步加载方式
    // loadSubMenu(id){
    //   let params = {pid:id}
    //   return new Promise((resolve) => {
    //     getAction(this.url.childList,params).then(res=>{
    //       if(res.success){
    //         console.log(res)
    //       }else{
    //         this.$message.warning(res.message)
    //       }
    //     })
    //   })
    // }
  },
  mounted() {
    // this.loadData();
  },
};
</script>
<style scoped>
.flex-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.topBar {
  margin-top: 10px;
  padding: 0px 26px;
  width: 100%;
  height: 50px;
  line-height: 10px;
  background-color: white;
  padding-top: 10px;
  background-color: #fcfcfc;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}
.content {
  width: 750px;
  height: 510px;
  background-color: white;
  overflow-y: auto;
  padding-left: 15px;
}
.menuRow {
  margin: 25px 20px 0 0;
}

.menuRow .menus {
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.menuRow .menuTitle {
  font-weight: bold;
  font-size: 13px;
  margin-top: 6px;
}
.menuRow .menus .ui-link {
  margin-right: 25px;
  font-size: 13px;
  font-weight: 400;
  line-height: 28px;
  display: inline-block;
}

* {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
a,
img {
  border: 0;
}

a {
  color: #666666;
  text-decoration: none;
  -webkit-transition-property: color;
  -moz-transition-property: color;
  -o-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.2s;
  -webkit-transition-timing-function: ease-in;
  -moz-transition-duration: 0.2s;
  -moz-transition-timing-function: ease-in;
  -o-transition-duration: 0.2s;
  -o-transition-timing-function: ease-in;
  transition-duration: 0.2s;
  transition-timing-function: ease-in;
}
a:hover {
  color: #f82b18;
  text-decoration: underline;
}

/* hc_lnav */
.hc_lnav {
  z-index: 2000;
  /* position: relative; */
  width: 900px;
  height: 600px;
}
.hc_lnav .allbtn {
  z-index: 2000;
  /* position: relative; */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 50px;
}
.hc_lnav .allbtn h2 {
  font-size: 14px;
  box-shadow: 2px 0px 6px -3px #428000;
  -webkit-box-shadow: 2px 0px 6px -3px #428000;
  -moz-box-shadow: 2px 0px 6px -3px #428000;
}
.hc_lnav .allbtn h2 a {
  line-height: 36px;
  background-color: #358000;
  padding-left: 10px;
  width: 180px;
  display: block;
  height: 36px;
  color: #ffffff;
  font-size: 14px;
  font-weight: normal;
}
.hc_lnav .allbtn h2 a:hover {
  background-color: #358000;
  text-decoration: none;
}
/*一级导航隐藏*/
.hc_lnav .allbtn ul {
  z-index: 99999;
  /* box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1); */
  background-color: #fcfcfc;
  border-radius: 6px;
  width: 190px;
  display: block;
  height: 352px;
  padding-top: 10px;
}
body.hc_home .hc_lnav .allbtn ul {
  display: block;
}
body.hc_list .hc_lnav .allbtn ul {
  display: block;
}
.hc_lnav .allbtn ul li {
  padding-bottom: 7px;
  zoom: 1;
  clear: both;
  cursor: default;
}
.hc_lnav .allbtn ul li .tx {
  /* background-image: url(../assets/pcImage/header_bg1.png); */
  line-height: 35px;
  padding-left: 25px;
  background-repeat: no-repeat;
  background-position: right center;
  height: 35px;
  _background-image: none;
  text-align: left;
  margin-left: 5px;
}
.hc_lnav .allbtn ul li .tx a {
  text-align: left;
  font-size: 14px;
  -webkit-transition: color 0.1s ease-out 0s;
  -moz-transition: color 0.1s ease-out 0s;
  -ms-transition: color 0.1s ease-out 0s;
  -o-transition: color 0.1s ease-out 0s;
  transition: color 0.1s ease-out 0s;
}
.hc_lnav .allbtn ul li .tx a span {
  font-weight: bold;
  font-size: 13px;
}
.hc_lnav .allbtn ul li .tx a .hotJob {
  font-size: 13px;
  font-weight: 400;
}
.hc_lnav .allbtn ul li .tx a i {
  line-height: 25px;
  margin-top: 5px;
  width: 25px;
  background-position: 0px 0px;
  float: left;
  height: 25px;
  margin-right: 10px;
  text-decoration: none;
}
.hc_lnav .allbtn ul li dl {
  zoom: 1;
  color: #ffffff;
  clear: both;
  overflow: auto;
  padding-top: 4px;
}
.hc_lnav .allbtn ul li dl a {
  line-height: 22px;
  white-space: nowrap;
  float: left;
  color: #d9e7ce;
  margin-left: 6px;
  margin-right: 6px;
  -webkit-transition: color 0.1s ease-out 0s;
  -moz-transition: color 0.1s ease-out 0s;
  -ms-transition: color 0.1s ease-out 0s;
  -o-transition: color 0.1s ease-out 0s;
  transition: color 0.1s ease-out 0s;
}
.hc_lnav .allbtn ul li dt {
  padding-left: 10px;
  width: 30px;
  float: left;
  padding-top: 1px;
}
.hc_lnav .allbtn ul li dd {
  line-height: 22px;
  width: 150px;
  float: left;
  padding-top: 2px;
}
/*二级导航隐藏*/
.hc_lnav .allbtn ul li .pop {
  border-style: none;
  /* position: absolute; */
  border-left: medium none;
  background-color: #fcfcfc;
  min-height: 466px;
  width: 100%;
  /* display: none; */
  border-top: medium none;
  /* top: 0px;  
  left: 190px; */
  /* box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1); */
}

.hc_lnav .allbtn ul li .pop .menus {
  text-align: left;
}

.hc_lnav .allbtn:hover ul {
  display: block;
} /*控制一级菜单显示隐藏*/
.hc_lnav .allbtn ul li:hover {
  background-color: #fcfcfc;
}
.hc_lnav .allbtn ul li:hover .tx {
  background-color: white;
  margin-left: 5px;
  border-left: 3px solid #7dcbdc;
}
.hc_lnav .allbtn ul li:hover .tx a {
  color: #333333;
}
.hc_lnav .allbtn ul li:hover .tx a i {
  background-position: 0px -25px;
}

.hc_lnav .allbtn ul li:hover .pop {
  display: block;
  top: 0px;
  left: 400px;
} /*控制二级菜单显示隐藏*/
.hc_lnav .allbtn ul li:hover .pop dl a.un {
  color: #a5a5a5;
  text-decoration: none;
}
.hc_lnav .allbtn ul li:hover dl {
  color: #6e6e6e;
}
.hc_lnav .allbtn ul li:hover a {
  color: #666666;
}
.hc_lnav .allbtn ul li:hover a:hover {
  color: #f82b18;
}
.more {
  margin: 39px 0 0 23px;
  font-size: 14px;
  font-weight: 400;
  color: #f82b18;
  line-height: 21px;
  text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
</style>